import { observer } from 'mobx-react-lite';
import React from 'react';

import type { Creative } from '@feathr/blackbox';
import { CreativeClass } from '@feathr/blackbox';
import CreativeThumbnail from '@feathr/extender/components/CreativeThumbnail';

import TLDR from '../../TLDR';

import * as styles from './CreativeTLDR.css';

interface IProps {
  creative?: Creative;
}

function CreativeTLDR({ creative }: IProps) {
  if (creative === undefined || creative.isPending) {
    return <TLDR isLoading={true} />;
  }

  const name = creative.get('name');
  const cls = creative.get('_cls') as CreativeClass;
  const hasLink = [
    CreativeClass.ReferralPage,
    CreativeClass.PartnerMessageEmail,
    CreativeClass.ReferralEmail,
  ].includes(cls);
  const link = hasLink ? creative.get('static_url') : undefined;

  // tslint:disable
  const spec =
    typeof creative['getSpec'] === 'function' ? (creative as Creative).getSpec() : undefined;
  // tslint:enable

  function getType() {
    if (spec) {
      return spec.name;
    }
    switch (cls) {
      case CreativeClass.ReferralPage:
        return 'Page';

      case CreativeClass.ReferralBanner:
        return 'Banner';

      case CreativeClass.ReferralEmail:
        return 'Email';

      default:
        return '-';
    }
  }

  const type = getType();

  return (
    <TLDR
      image={<CreativeThumbnail className={styles.root} creative={creative.toJS()} size={200} />}
      isLoading={false}
      link={link}
      rowReverse={true}
    >
      <div>
        <span>{name}</span>
        <br />
        <span>{type}</span>
      </div>
    </TLDR>
  );
}

export default observer(CreativeTLDR);
